import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserAccessService } from '../../services/user-access.service';
// import { TranslateService } from '@ngx-translate/core';
import { environment } from 'environments/environment';
import { UserAlertSearch, UserAlertUpdate } from 'app/shared/models/Alerts';
import { DateUtilityService } from 'app/shared/services/dateUtility.service';
import { AnnouncementsService } from 'app/layout/announcements/announcements.service';
import { AlertViewComponentModal } from 'app/layout/announcements/detail/modals/alert-view-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'app-header',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
	public accountMenuCollapsed = true;

	assetPath = environment.assetPath;
	navbarCollapsed = true;
	reportsCollapsed = true;
	nameCollapsed = true;
	OpenNotProcessingSecurable = false;
	ProcessingTotalsSecurable = false;
	InstallationsSecurable = true;

	public get NotificationCount() {
		return this.annSvc.NotificationCount;
	}

	public get Data() {
		return this.annSvc.bellAlerts.ual;
	}

	constructor(
		public router: Router,
		public userAccessService: UserAccessService,
		public location: Location,
		private dateUtil: DateUtilityService,
		private annSvc: AnnouncementsService,
		private modalService: NgbModal,
		private accessSvc: UserAccessService
	) {
		/****REMOVED BECAUSE IT WAS GETTING APPLIED TO ALL LINKS THAT ARE USING ROUTER EVENT,
		CAUSING THE TOP NAV TO OPEN WHEN CLICKED.
		CAN BE REMOVED FROM CODE ONCE APPROVED.******/
		/*this.router.events.subscribe(val => {
			if (val instanceof NavigationEnd && window.innerWidth <= 992) {
				this.toggleSidebar();
			}
		});*/
	}

	ngOnInit() {
		this.ToggleCollapses();
		this.annSvc.populateBellAlerts();

		this.accessSvc.GetAccessLevelBySecurableName('|OPEN-NOT-PROCESSING', 'REPORTS', null, null, false).then(resp => {
			if (resp > 0) {
				// They have at least read access
				this.OpenNotProcessingSecurable = true;
			}
		});

		this.accessSvc.GetAccessLevelBySecurableName('|PROCESSING-TOTALS', 'REPORTS', null, null, false).then(resp => {
			if (resp > 0) {
				// They have at least read access
				this.ProcessingTotalsSecurable = true;
			}
		});
		this.accessSvc.GetAccessLevelBySecurableName('|INSTALLATIONS', 'REPORTS', null, null, false).then(resp => {
			if (resp > 0) {
				// They have at least read access
				this.InstallationsSecurable = true;
			}
		});
	}

	// toggleSidebar() {
	// 	// const dom: any = document.querySelector('body');
	// 	// dom.classList.toggle('push-right');
	// 	this.isCollapsed = !this.isCollapsed;
	// }
	ToggleCollapses() {
		if (this.router.url.toUpperCase().indexOf('/REPORTS') >= 0) {
			this.reportsCollapsed = false;
		}
	}

	rltAndLtr() {
		const dom: any = document.querySelector('body');
		dom.classList.toggle('rtl');
	}

	getUserAccountName(): string {
		// TODO: hook up to user info
		return this.userAccessService.UserName;
	}

	onLoggedout() {
		localStorage.removeItem('isLoggedin');
	}

	changeLang(language: string) {
		// this.translate.use(language);
	}

	get showApplications(): boolean {
		return this.userAccessService.canBoard;
	}

	redirectToAnnouncements() {
		this.router.navigate(['/alerts/detail']);
	}

	viewAlert(UserAlertID: number) {
		const modalRef = this.modalService.open(AlertViewComponentModal, { size: 'lg', backdrop: 'static' });
		modalRef.componentInstance.UserAlertID = UserAlertID;
		modalRef.result.then((result: string) => {
			if (result) {
				if (result === 'read') {
					this.annSvc.populateBellAlerts();
				}
			} else {
				console.log('User cancelled dialog');
			}
		});
	}

	public markAsRead(UserAlertID: number) {
		this.annSvc.UserAlertSetViewed(UserAlertID).toPromise().then(resp => {
			this.annSvc.populateBellAlerts();
		}).catch(resp => {
			alert('There was a problem marking this notification, please try again.');
		});
	}

}
